import React, { useEffect } from "react"
import { useParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { getBooking, cleanBooking } from "store/bookings"
import { cleanTrip, receivedTrip } from "store/trips"
import { TripsPreview } from "components/trips/TripsPreview"
import Spinner from "components/common/Spinner"
import { useTitle } from "hooks/useTitle"
import GuestHeader from "layoutsV2/client/GuestHeader"
import { Flex } from "antd"

const ClientGuestBookingConfirmation = () => {
  const params = useParams()
  const dispatch = useDispatch()
  const { booking } = useSelector((store) => store.bookings)
  const { trip, loading } = booking
  const isLoggedIn = !!localStorage.getItem("access_token")
  useTitle(trip?.title)

  useEffect(() => {
    dispatch(getBooking(params.id)).then(({ trip }) => dispatch(receivedTrip(trip)))
    return () => dispatch(cleanBooking()) && dispatch(cleanTrip())
  }, [params.id, dispatch])

  if (loading)
    return (
      <Flex justify="center" align="center" className="min-vh-100">
        <Spinner />
      </Flex>
    )

  return (
    <main className="min-vh-100 bg-light">
      <GuestHeader hideUserControls={!isLoggedIn} />
      <div className="min-h-100 py-15 layout-wrapper">{booking.id && <TripsPreview />}</div>
    </main>
  )
}

export default ClientGuestBookingConfirmation
